import script from "./PartCollectionsLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./PartCollectionsLayout.vue?vue&type=script&setup=true&lang=ts"

import "./PartCollectionsLayout.vue?vue&type=style&index=0&id=7d16e87c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d16e87c"]])

export default __exports__